namespace TabAurous.OMS {
    export interface FinancialYearRow {
        FinancialYearId?: number;
        FromDate?: string;
        ToDate?: string;
        FinancialYearCode?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace FinancialYearRow {
        export const idProperty = 'FinancialYearId';
        export const nameProperty = 'FinancialYearCode';
        export const localTextPrefix = 'OMS.FinancialYear';
        export const lookupKey = 'OMS.FinancialYear';

        export function getLookup(): Q.Lookup<FinancialYearRow> {
            return Q.getLookup<FinancialYearRow>('OMS.FinancialYear');
        }
        export const deletePermission = 'Masters:FinancialYear:Delete';
        export const insertPermission = 'Masters:FinancialYear:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:FinancialYear:Edit';

        export declare const enum Fields {
            FinancialYearId = "FinancialYearId",
            FromDate = "FromDate",
            ToDate = "ToDate",
            FinancialYearCode = "FinancialYearCode",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
